// extracted by mini-css-extract-plugin
module.exports = {"itemHeader":"service-dialog_itemHeader__BY6m7","menu":"service-dialog_menu__AwVSh"};